export const ADDRESS_DETAILS = [
    {
        label: 'Street address',
        formControlName: 'streetaddress'
    },
    {
        label: 'Country',
        formControlName: 'country'
    },
    {
        label: 'State',
        formControlName: 'state'
    },
    {
        label: 'Zip code',
        formControlName: 'zipcode'
    },
]

export enum AnimationKey {
    payment_success = "/assets/animation/payment-success.json",
    loader = "/assets/animation/loading.json",
    check_mark = "/assets/animation/check-mark.json"
}